import React from "react"
import {Button, Stack, Typography} from "@mui/material"
import Grid from "@mui/material/Grid2";
import { DateTime } from 'luxon'
import BackButton from "./Common/BackButton"
import {useTranslation} from "react-i18next"
import {RegisterInfo} from "../../Redux/reservationRedux";

interface VehicleFoundProps {
    registerInfo: RegisterInfo
    handleContinue: () => void
    hasOtherReservation: boolean
    onBack: () => void
}

const NOTICE_WAIT_TIME_THRESHOLD = 60 * 60 * 1000 // 1 hour

const VehicleFound = ({registerInfo, handleContinue, hasOtherReservation, onBack}: VehicleFoundProps) => {
    const { t } = useTranslation()

    const nextAvailableTime = DateTime.fromISO(registerInfo.nextAvailableTime)
    const nextAvailableTimeAt = nextAvailableTime?.diffNow()?.milliseconds > NOTICE_WAIT_TIME_THRESHOLD ? nextAvailableTime.minus({minutes: nextAvailableTime.minute % 15}).toFormat('HH:mm') : null

    return (
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className={'pageMainContainer'}>
            <Grid>
            </Grid>
            <Grid justifyItems="center" style={{textAlign: 'center'}}>
                <Typography variant="h4" gutterBottom>{t('selfService.vehicleFound')}</Typography>
                <Stack direction="row" spacing={4} className="contentWithMargin">
                    <div style={{width: 'fit-content'}}>
                        <Typography variant="h1" noWrap className="registrationNumber">{registerInfo.registrationNumber}</Typography>
                    </div>
                    <div style={{marginTop: '0.75rem', marginRight: '-1.5em', textAlign: 'start'}}>
                        <Typography variant="h5" style={{height: '1.5em', overflowY: 'hidden'}}>{registerInfo.manufacturer.name} {registerInfo.model}</Typography>
                        <Typography variant="subtitle1" >{registerInfo.vehicleClass.name}</Typography>
                    </div>
                </Stack>
                {nextAvailableTimeAt ? <div className="contentWithMargin" style={{marginTop: '2em'}}>
                    <Typography variant="body1" color="error">Huom! Seuraava vapaa aika on noin kello {nextAvailableTimeAt}</Typography>
                </div> : null}
                {hasOtherReservation ? <div className="contentWithMargin" style={{marginTop: '2em'}}>
                    <Typography variant="body1" color="error">{t('selfService.otherReservationNotice')}</Typography>
                </div> : null}
            </Grid>
            <Grid className="footerButtons">
                <Grid container wrap="nowrap" spacing={4} justifyContent="space-between" alignItems="end">
                    <Grid>
                        <BackButton onBack={onBack} />
                    </Grid>
                    <Grid>
                        <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            onClick={handleContinue}
                        >
                            {t('common.continue')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default VehicleFound
